import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  progressiveImages: {
    size: 1, // Use higher-resolution previews
    sharp: true // Use sharp instead of ImageMagick
  }
}

export default new Vuetify(opts)
